import { TYPE_BOOLEAN } from './input-types';

export const id = 'packingSlip';
export const apiKey = 'IsPackingSlipPrinted';
export const type = TYPE_BOOLEAN;

export const packingSlip = {
  id,
  apiKey,
  type,
};
